import { ref } from 'vue'

/**
 * @param {{
 *   mailResult: Boolean
 * }} props
 */
export const setup = props => {
  const self = {
    modalVisible: ref(props.mailResult),

    closeModal: () => {
      self.modalVisible.value = false
      return self
    },
  }

  return {
    // props
    modalVisible: self.modalVisible,

    // functions
    closeModal: self.closeModal,
  }
}
